import styles from './ApartmentCardMedia.module.scss';
import ImageGallery from '../../ImageGallery';
import { FC, useState } from 'react';
import { IMedia } from '@wohnsinn/ws-ts-lib';
import { useTranslation } from 'react-i18next';

const ApartmentCardMedia: FC<{
  media: IMedia[];
  apartmentId: string;
  isIntersecting?: boolean;
  onGalleryClick?: any;
  reelsView?: boolean;
  showBouncingHeart?: boolean;
}> = ({ media, apartmentId, isIntersecting, onGalleryClick, reelsView = false, showBouncingHeart }) => {
  const { t } = useTranslation('common');
  const [slideShowIndex, setSlideShowIndex] = useState(0);
  return (
    <div
      className={`${styles.image} ${reelsView ? styles.reelsView : ''} ${
        showBouncingHeart ? styles.showBouncingHeart : ''
      }`}
    >
      {media && media.length && isIntersecting ? (
        <ImageGallery
          reelsView
          id={apartmentId}
          noLightBox
          setSlideShowIndex={setSlideShowIndex}
          slideShowIndex={slideShowIndex}
          media={media}
          onClick={onGalleryClick}
        />
      ) : (
        <button onClick={onGalleryClick}>
          <img
            loading="lazy"
            className={`${styles.placeholder} ${reelsView ? styles.reelsView : ''}`}
            alt={'placeholder-apartment-image'}
            src={t('apartmentPlaceholder')}
          />
        </button>
      )}
    </div>
  );
};

export default ApartmentCardMedia;
